var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDumbbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493 275h-38v-38h38c10 0 19 8 19 19s-9 19-19 19z",
    fill: "#efedee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d2d3",
    d: "M455 237h28v39h-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M438 344c-18 0-33-15-33-34V202c0-19 15-34 33-34 19 0 34 15 34 34v108c0 19-15 34-34 34z",
    fill: "#313d40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#efedee",
    d: "M142 220h229v72H142z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d2d3",
    d: "M338 301l-21-9v-72l21-9h12v90z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405 374c-19 0-34-15-34-34V172c0-19 15-34 34-34 18 0 33 15 33 34v168c0 19-15 34-33 34z",
    fill: "#3a484a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M416 340V172c0-10 4-19 11-25-6-5-13-9-22-9-19 0-34 15-34 34v168c0 19 15 34 34 34 9 0 16-4 22-9-7-6-11-15-11-25z",
    fill: "#313d40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M371 415c-18 0-33-15-33-33V130c0-18 15-33 33-33 19 0 34 15 34 33v252c0 18-15 33-34 33z",
    fill: "#3a484a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361 382V130c0-14 9-27 22-31-4-2-8-2-12-2-18 0-33 15-33 33v252c0 18 15 33 33 33 4 0 8 0 12-2-13-4-22-17-22-31z",
    fill: "#313d40"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 275h38v-38H19c-10 0-19 8-19 19s9 19 19 19z",
    fill: "#efedee"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d2d3",
    d: "M28 237h28v39H28z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74 344c18 0 33-15 33-34V202c0-19-15-34-33-34-19 0-34 15-34 34v108c0 19 15 34 34 34z",
    fill: "#313d40"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d2d3",
    d: "M174 301l21-9v-72l-21-9h-12v90z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107 374c19 0 34-15 34-34V172c0-19-15-34-34-34-18 0-33 15-33 34v168c0 19 15 34 33 34z",
    fill: "#3a484a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96 340V172c0-10-4-19-11-25 6-5 13-9 22-9 19 0 34 15 34 34v168c0 19-15 34-34 34-9 0-16-4-22-9 7-6 11-15 11-25z",
    fill: "#313d40"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141 415c18 0 33-15 33-33V130c0-18-15-33-33-33-19 0-34 15-34 33v252c0 18 15 33 34 33z",
    fill: "#3a484a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151 382V130c0-14-9-27-22-31 4-2 8-2 12-2 18 0 33 15 33 33v252c0 18-15 33-33 33-4 0-8 0-12-2 13-4 22-17 22-31z",
    fill: "#313d40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.c2230fdd98012fb6f16a6c6fa81a44d9.svg";
export { ForwardRef as ReactComponent };